import React from "react";
import { FAQS } from "@/data/site";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-28 px-5 md:px-8 bg-[#F8FAFC]">
      <div className="max-w-4xl mx-auto">
        <div className="text-center flex flex-col items-center">
          <SectionHeading
            eyebrow="FAQ"
            title="Frequently asked questions"
            subtitle="Everything you'd want to know before booking your next journey with us."
            align="center"
          />
        </div>

        <Reveal>
          <Accordion type="single" collapsible className="mt-12 w-full space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white rounded-2xl border border-gray-100 px-5 md:px-6 shadow-sm hover:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-[#0B3D91] hover:text-[#F9B233] py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] text-[#555] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
